import { useFormik } from "formik";
import React, {
  forwardRef,
  useImperativeHandle,
  useRef,
  //useState,
} from "react";
/*import innerStyle from "./Login.module.css";
import styles from "../../../styles/Username.module.css";
import extend from "../../../styles/Profile.module.css";*/
//import { PiUser } from "react-icons/pi";
import { IoLockClosedOutline } from "react-icons/io5";
import * as api from "helper/helper";
import { newPasswordConfirmValidate } from "../../../../helper/validate";
import toast from "react-hot-toast";
import invalidClass from "../../helperFunctions/helpers";

const NewPasswordConfirmModal = forwardRef(({ username, onOk }, ref) => {
  const modalButtonRef = useRef();

  useImperativeHandle(ref, () => ({
    toggleModal: () => {
      formik?.resetForm();
      modalButtonRef.current.click();
    },
  }));

  const formik = useFormik({
    initialValues: {
      password: "",
      confirmPassword: "",
    },
    enableReinitialize: true,
    validate: newPasswordConfirmValidate,
    validateOnBlur: true,
    validateOnChange: false,
    validateOnMount: true,
    onSubmit: async (values, onSubmitProps) => {
      let response = await api
        .resetPassword(username, values.password)
        .catch((error) => {
          toast.error(error.mensaje ?? "ResetPassword Error!");
        });
      if (!response) return;

      if (!response.data.esError) {
        toast.success(response.data.mensaje ?? "ResetPassword Successfully!");
        modalButtonRef.current.click();

        onOk({ username, password: values.password });

        formik.resetForm();
      } else {
        toast.error(response.data.mensaje ?? "ResetPassword Successfully!");
      }
    },
  });

  return (
    <>
      {/*<!-- Button trigger modal -->*/}
      <button
        ref={modalButtonRef}
        type="button"
        className="btn btn-primary"
        data-bs-toggle="modal"
        data-bs-target="#staticBackdropNewPasswordConfirm"
        hidden
      >
        Launch static backdrop modal
      </button>

      {/*<!-- Modal -->*/}
      <div
        className="modal fade"
        id="staticBackdropNewPasswordConfirm"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
        tabIndex="-1"
        aria-labelledby="staticBackdropNewPasswordConfirmLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h5
                className="modal-title"
                id="staticBackdropNewPasswordConfirmLabel"
              >
                Nuevo Password
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <form className="row g-3" onSubmit={formik.handleSubmit}>
              <div className="modal-body">
                Teclee el nuevo password
                <div className={`col-md-12`}>
                  <label
                    htmlFor="validationDefaultConfirmPassword"
                    className="form-label"
                    hidden
                  ></label>
                  <div className="input-group">
                    <span className="input-group-text" id="inputGroupPrepend2">
                      <IoLockClosedOutline />
                    </span>
                    <input
                      type="text"
                      className={`form-control ${invalidClass(
                        formik.errors.password,
                      )}`}
                      id="validationDefaultConfirmPassword"
                      aria-describedby="inputGroupPrepend2"
                      placeholder="Nuevo Password"
                      required
                      {...formik.getFieldProps("password")}
                    />
                    <div className="invalid-feedback">
                      {formik.errors.password}
                    </div>
                  </div>
                </div>
                <div className={`col-md-12`}>
                  <label
                    htmlFor="validationDefaultConfirmPassword"
                    className="form-label"
                    hidden
                  ></label>
                  <div className="input-group">
                    <span className="input-group-text" id="inputGroupPrepend2">
                      <IoLockClosedOutline />
                    </span>
                    <input
                      type="text"
                      className={`form-control ${invalidClass(
                        formik.errors.confirmPassword,
                      )}`}
                      id="validationDefaultConfirmPassword"
                      aria-describedby="inputGroupPrepend2"
                      placeholder="Confirmar Password"
                      required
                      {...formik.getFieldProps("confirmPassword")}
                    />
                    <div className="invalid-feedback">
                      {formik.errors.confirmPassword}
                    </div>
                  </div>
                </div>
                <div className="col-md-12">
                  <label
                    htmlFor="validationDefaultConfirmPassword"
                    className="form-label"
                    hidden
                  ></label>
                </div>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  data-bs-dismiss="modal"
                >
                  Cerrar
                </button>
                <button
                  className="btn btn-primary"
                  type="submit"
                  disabled={formik.isSubmitting}
                >
                  Enviar
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
});

export default NewPasswordConfirmModal;
